import { SecurityaddonsService } from './../../securityaddons/services/securityaddons.service';
import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
class BreachGuardService {
    constructor(private router: Router, private securityaddonsService: SecurityaddonsService) {}

    public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
        if (this.securityaddonsService.showBreachWarrantyIntegration()) {
            return true;
        }
        return this.router.parseUrl('/');
    }
}

export const BreachGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {
    return inject(BreachGuardService).canActivate(next, state);
};
